import {Component} from "react";
import '../styles/MarketsStyles.css'
import Pulse from "react-reveal/Pulse";

class Markets extends Component {
    render() {
        return(
            <div className={"markets"}>
                <Pulse forever={true} duration={2000}>
                <div className={"market"}>
                    <a href={'https://play.google.com/store/apps/details?id=org.devlee.android.csn'}></a>
                </div>
                </Pulse>
                <Pulse forever={true} delay={250} duration={2000}>
                <div className={"market"}>
                    <a href={'https://apps.apple.com/ru/app/%D1%81%D0%BE%D1%86%D0%B8%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BD%D0%B0%D0%B2%D0%B8%D0%B3%D0%B0%D1%82%D0%BE%D1%80/id1527576871'}></a>
                </div>
                </Pulse>
                <Pulse forever={true} delay={500} duration={2000}>
                <div className={"market"}>
                    <a href={'https://appgallery.cloud.huawei.com/ag/n/app/C105922005?locale=ru_RU&source=appshare&subsource=C105922005&shareTo=com.android.bluetooth&shareFrom=appmarket&shareIds=1222ea6e1cf4496bbad4ece2142d4d74_com.android.bluetooth&callType=SHARE'}></a>
                </div>
                </Pulse>
            </div>
        );
    }
}
export default Markets;